import { UseCase } from "@/services/global-services/models";
import { DataTableColumnDefinition, DataTableConfig, DataTableFootnote, DataTableRow } from "../Models";

export enum ActionType {
    InitializeDataSource,
    RestoreDataSource,
    UpdateConfig,
    PasteData,

    EnsureEmptyRow,
    InsertRow,
    RemoveRow,
    SetRowVisibility,

    MoveRowDown,
    MoveRowUp,

    SetCellContent,

    AddCellFootnote,
    UpdateFootnote,
    ClearCellFootnotes,

    SetColumnFilterFunction,
    SetRowFilterFunction,
    SetUseCaseFilterFunction,

    SetActiveDisciplines,

    SetTableCaption,
}

export interface InitializeDataSource {
    type: ActionType.InitializeDataSource;
}

export interface RestoreDataSource {
    type: ActionType.RestoreDataSource;
    payload: { ignoreChanges: boolean; ignoreVisibility: boolean; ignoreFootnotes: boolean };
}

export interface UpdateConfig {
    type: ActionType.UpdateConfig;
    payload: { config: DataTableConfig };
}

export interface PasteData {
    type: ActionType.PasteData;
    payload: { data: DataTableRow[]; row?: string };
}

export interface EnsureEmptyRow {
    type: ActionType.EnsureEmptyRow;
}

export interface InsertRow {
    type: ActionType.InsertRow;
    payload: { focus: boolean };
}

export interface RemoveRow {
    type: ActionType.RemoveRow;
    payload: { id: string };
}

export interface SetRowVisibility {
    type: ActionType.SetRowVisibility;
    payload: { id: string; visible: boolean };
}

export interface MoveRowDown {
    type: ActionType.MoveRowDown;
    payload: { id: string };
}

export interface MoveRowUp {
    type: ActionType.MoveRowUp;
    payload: { id: string };
}

export interface SetCellContent {
    type: ActionType.SetCellContent;
    payload: { row: string; cell: string; value: string };
}

export interface SetCellFootnote {
    type: ActionType.AddCellFootnote;
    payload: { row: string; cell: string; footnote: DataTableFootnote };
}

export interface UpdateFootnote {
    type: ActionType.UpdateFootnote;
    payload: { id: string; value: string };
}

export interface ClearCellFootnote {
    type: ActionType.ClearCellFootnotes;
    payload: { row: string; cell: string };
}

export interface SetColumnFilterFunction {
    type: ActionType.SetColumnFilterFunction;
    payload: { func: (col: DataTableColumnDefinition) => boolean };
}

export interface SetRowFilterFunction {
    type: ActionType.SetRowFilterFunction;
    payload: { func: (row: DataTableRow) => boolean };
}

export interface SetUseCaseFilterFunction {
    type: ActionType.SetUseCaseFilterFunction;
    payload: { func: (useCase: UseCase) => boolean };
}

export interface SetActiveDisciplines {
    type: ActionType.SetActiveDisciplines;
    payload: { disciplines: string[] };
}

export interface SetTableCaption {
    type: ActionType.SetTableCaption;
    payload: { caption: string };
}

export type DataTableActions =
    | InitializeDataSource
    | RestoreDataSource
    | UpdateConfig
    | PasteData
    | EnsureEmptyRow
    | InsertRow
    | RemoveRow
    | SetRowVisibility
    | MoveRowDown
    | MoveRowUp
    | SetCellContent
    | SetCellFootnote
    | UpdateFootnote
    | ClearCellFootnote
    | SetColumnFilterFunction
    | SetRowFilterFunction
    | SetUseCaseFilterFunction
    | SetActiveDisciplines
    | SetTableCaption;
